function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Decimal from 'decimal.js';
import { utils } from "../utils";
import { DiscountPeriodExpirationModel } from "./DiscountPeriodExpirationModel";
export let DiscountType = /*#__PURE__*/function (DiscountType) {
  DiscountType["Value"] = "value";
  DiscountType["Percent"] = "percent";
  return DiscountType;
}({});
export let DiscountDTOType = /*#__PURE__*/function (DiscountDTOType) {
  DiscountDTOType["Percent"] = "percent";
  DiscountDTOType["Value"] = "value";
  DiscountDTOType["None"] = "none";
  return DiscountDTOType;
}({});
export class DiscountModel {
  static make(type, amount, expiration) {
    return new DiscountModel({
      type,
      amount: new Decimal(amount),
      expiration
    });
  }
  static makePercent(amount, expiration) {
    return DiscountModel.make(DiscountType.Percent, amount, expiration);
  }
  static makeValue(amount, expiration) {
    return DiscountModel.make(DiscountType.Value, amount, expiration);
  }
  static fromDTO(dto) {
    if (dto == null) return null;
    switch (dto.type) {
      case DiscountDTOType.Percent:
        {
          const expirationData = dto.expirationV2;
          return new DiscountModel({
            type: DiscountType.Percent,
            amount: new Decimal(dto.temp_amount).div(100),
            expiration: expirationData ? DiscountPeriodExpirationModel.fromDTO(expirationData) : undefined
          });
        }
      case DiscountDTOType.Value:
        {
          const expirationData = dto.expirationV2;
          return new DiscountModel({
            type: DiscountType.Value,
            amount: new Decimal(dto.temp_amount).div(100),
            expiration: expirationData ? DiscountPeriodExpirationModel.fromDTO(expirationData) : undefined
          });
        }
      case DiscountDTOType.None:
        return null;
    }
  }
  static fromDBDTO(dto) {
    if (!dto || dto.type === DiscountDTOType.None) return null;
    const expiration = dto.expiration ? DiscountPeriodExpirationModel.fromDBDTO(dto.expiration) : undefined;
    return new DiscountModel({
      type: dto.type === DiscountDTOType.Percent ? DiscountType.Percent : DiscountType.Value,
      amount: new Decimal(dto.decimal).div(100),
      expiration
    });
  }
  constructor(discount) {
    this.discount = discount;
  }
  toDTO() {
    return _objectSpread({
      type: this.discount.type === DiscountType.Percent ? DiscountDTOType.Percent : DiscountDTOType.Value,
      amount: this.discount.amount.toNumber(),
      temp_amount: this.discount.amount.mul(100).toNumber()
    }, this.discount.expiration && {
      expirationV2: this.discount.expiration.toDTO()
    });
  }
  toDBDTO() {
    return _objectSpread({
      type: this.discount.type === DiscountType.Percent ? DiscountDTOType.Percent : DiscountDTOType.Value,
      decimal: this.discount.amount.mul(100).toNumber()
    }, this.discount.expiration && {
      expiration: this.discount.expiration.toDBDTO()
    });
  }
  type() {
    return this.discount.type;
  }
  isPercent() {
    return this.discount.type === DiscountType.Percent;
  }
  isValue() {
    return this.discount.type === DiscountType.Value;
  }
  isSameAs(other) {
    return this.discount.type === other.discount.type && this.discount.amount.equals(other.discount.amount);
  }
  amount() {
    return this.discount.amount;
  }
  accept(visitor) {
    switch (this.discount.type) {
      case DiscountType.Value:
        return visitor.whenValue();
      case DiscountType.Percent:
        return visitor.whenPercent();
    }
  }
  format() {
    let {
      showValueAsNegative
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return this.discount.type === DiscountType.Value ? utils.formatDollarAmount(showValueAsNegative ? this.discount.amount.neg() : this.discount.amount) : "".concat(utils.formatNumberWithCommas(this.discount.amount), "%");
  }
  setExpiration(expiration) {
    return new DiscountModel(_objectSpread(_objectSpread({}, this.discount), {}, {
      expiration: expiration !== null && expiration !== void 0 ? expiration : DiscountPeriodExpirationModel.makeNone()
    }));
  }
  expiration() {
    return this.discount.expiration;
  }
}